export const MARKETING_CLICKED = 'Marketing Clicked'
export const LEARN_MORE_CLICKED = 'Learn More Clicked'
export const ADD_TO_LIBRARY_CLICKED = 'Add To SLSO Clicked'
export const DOWNLOAD_CLICKED = 'Download Clicked'
export const DOWNLOAD_NOTEBOOK_TRIAL_CLICKED = 'Download Notebook Trial Clicked'
export const TERMS_CLICKED = 'Terms Clicked'
export const DOWNLOADING_RESOURCE = 'Downloading Resource'
export const SEARCH_RESOURCES = 'Search'
export const RESOURCE_PREVIEWED = 'Resource Previewed'
export const FILTER_UPDATE = 'Filters Updated'
export const BROWSING_RESOURCE_IMAGES = 'Browsing Resource Images'
export const PAGED_NEXT = 'Paged Next'
export const PAGED_BACK = 'Paged Back'
export const VIEWING_SEARCH_RESULTS = 'Viewing Search Results'
export const UPDATED_SORTING = 'Updated Sorting'
export const CLAIMED_AUTHORSHIP = 'Claimed Authorship'
export const HOMEPAGE_OPENED = 'Opened Homepage'
export const FILE_ADDED_FOR_UPLOAD = 'File Added For Upload'
export const FILE_UPLOADED = 'File Uploaded'
export const FILE_UPDATED = 'File Updated'
export const FILE_PROCESSED = 'File Processed'
export const FILE_PROCESSING_FAILED = 'File Processing Failed'
export const FILE_CONTAINS_UNSUPPORTED_CONTENT = 'File Contains Unsupported Content'
export const FILE_SHARED = 'File Shared'
export const FILE_EDITED = 'File Edited'
export const FILE_DELETED = 'File Deleted'
export const NOTEBOOK_REDIRECT = 'Notebook Redirect'
export const SHARED_TO_TWITTER = 'Shared to twitter'
export const SHARED_TO_PINTEREST = 'Shared to pinterest'
export const SHARED_TO_FACEBOOK = 'Shared to facebook'
export const SHARED_TO_EMAIL = 'Shared to email'
